'use client';

import { useEffect } from 'react';

export function StaticLandingNavbarMenuEnhancer() {
  useEffect(() => {
    const menu = document.querySelector<HTMLDetailsElement>('[data-static-landing-mobile-menu]');
    if (!menu) return;

    const closeMenu = () => {
      menu.open = false;
    };

    const handlePointerDown = (event: PointerEvent) => {
      if (!menu.open) return;
      if (event.target instanceof Node && menu.contains(event.target)) return;
      closeMenu();
    };

    const handleClick = (event: MouseEvent) => {
      // event.target may not be an Element (text node, etc.) — guard before .closest
      if (event.target instanceof Element && event.target.closest('a')) closeMenu();
    };

    document.addEventListener('pointerdown', handlePointerDown);
    menu.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('pointerdown', handlePointerDown);
      menu.removeEventListener('click', handleClick);
    };
  }, []);

  return null;
}

export default StaticLandingNavbarMenuEnhancer;
